<div class="filter-container">
    <div
        class="search-overlay"
        (click)="closeModal()"></div>
    <div class="filter-box">
        <div class="filter-header">
            <div class="header-text">Filter by Provider</div>
            <div
                class="filter-close"
                (click)="closeModal()">
                <img
                    src="assets/images/svg/close.svg"
                    alt=""
                    width="16"
                    height="16" />
            </div>
        </div>

        <div class="filter-content">
            <!-- <div class="filter-sort">
                <div class="filter-title">Sort by</div>
                <div class="option-list">
                    <button type="button" class="option-btn primary">Popularity</button>
                    <button type="button" class="option-btn">A-Z</button>
                </div>
            </div> -->
            <div class="filter-provider">
                <div class="provider-wrapper">
                    @for (provider of providers; track provider) {
                        <div class="wrapper">
                            <div
                                class="checkbox-container"
                                [class.active]="selectedProviders.has(provider.provider)">
                                <input
                                    type="checkbox"
                                    name="filterCheck"
                                    id="{{ provider.provider }}"
                                    (change)="onProviderSelectionChange(provider.provider, $event)"
                                    [checked]="selectedProviders.has(provider.provider)" />
                                @if (selectedProviders.has(provider.provider)) {
                                    <img
                                        src="assets/images/svg/checkmark.svg"
                                        alt=""
                                        width="17"
                                        height="17"
                                        class="checkmark" />
                                }
                            </div>
                            <label
                                for="{{ provider.provider }}"
                                class="label">
                                {{ provider.provider }}

                                <div class="provider-games">
                                    {{ provider.count }}
                                    <span class="count-text">Games</span>
                                </div>
                            </label>
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="filter-footer">
            @if (selectedProvidersState.length > 0 || selectedProviders.size > 0) {
                @if (selectedProviders.size > 0) {
                    <button
                        type="button"
                        class="secondary-type btn"
                        (click)="clearFilters()">
                        CLEAR
                    </button>
                }
                <button
                    type="button"
                    class="primary-type btn"
                    (click)="applyFilters()">
                    APPLY FILTERS
                </button>
            } @else if (selectedProviders.size <= 0) {
                <button
                    type="button"
                    class="primary-type btn"
                    (click)="closeModal()">
                    CLOSE
                </button>
            }
        </div>
    </div>
</div>
